import { render } from "./CardItem.vue?vue&type=template&id=4c88f6f6&scoped=true"
import script from "./CardItem.vue?vue&type=script&lang=js"
export * from "./CardItem.vue?vue&type=script&lang=js"

import "./CardItem.vue?vue&type=style&index=0&id=4c88f6f6&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c88f6f6"]])

export default __exports__